import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EditorDragAndDrop = ({ height = 97, width = 174, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 174 97" {...props}>
    <path
      fill="#FFFFFF"
      d="M9,1h156c4.4,0,8,3.6,8,8v79c0,4.4-3.6,8-8,8H9c-4.4,0-8-3.6-8-8V9C1,4.6,4.6,1,9,1z"
    />
    <path
      fill="none"
      stroke="#F5F4F4"
      d="M9,0.5h156c4.7,0,8.5,3.8,8.5,8.5v79c0,4.7-3.8,8.5-8.5,8.5H9c-4.7,0-8.5-3.8-8.5-8.5V9
      C0.5,4.3,4.3,0.5,9,0.5z"
    />
    <path fill="#F5F4F4" d="M1,9c0-4.4,3.6-8,8-8h124v95H9c-4.4,0-8-3.6-8-8V9z" />
    <path
      fill="#FFFFFF"
      d="M42,7h59c2.2,0,4,1.8,4,4v74c0,2.2-1.8,4-4,4H42c-2.2,0-4-1.8-4-4V11C38,8.8,39.8,7,42,7z"
    />
    <path
      fill="none"
      stroke="#E0DEDF"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeDasharray="4,4"
      d="M51,45.8h41
      c1.8,0,3.2,1.5,3.2,3.2v29c0,1.8-1.5,3.2-3.2,3.2H51c-1.8,0-3.2-1.5-3.2-3.2V49C47.8,47.2,49.2,45.8,51,45.8z"
    />
    <path
      fill="#B56DC6"
      d="M95,42L95,42c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4l0,0c-2.2,0-4-1.8-4-4l0,0C91,43.8,92.8,42,95,42z"
    />
    <path
      fill="#B56DC6"
      d="M38,17L38,17c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4l0,0c-2.2,0-4-1.8-4-4l0,0C34,18.8,35.8,17,38,17z"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="46.8"
      y1="32.2"
      x2="72.2"
      y2="32.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="46.8"
      y1="26.2"
      x2="66.2"
      y2="26.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="46.8"
      y1="20.2"
      x2="82.2"
      y2="20.2"
    />
    <path
      fill="#E0DEDF"
      d="M143,37h6c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-6C141,37.9,141.9,37,143,37z"
    />
    <path
      fill="#E0DEDF"
      d="M157,23h6c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-6C155,23.9,155.9,23,157,23z"
    />
    <path
      fill="#34C3F2"
      d="M143,23h6c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-6C141,23.9,141.9,23,143,23z"
    />
    <path
      fill="#B56DC6"
      d="M157,9h6c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-6C155,9.9,155.9,9,157,9z"
    />
    <path
      fill="#59C1A7"
      d="M143,9h6c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-6C141,9.9,141.9,9,143,9z"
    />
  </SvgIcon>
);
